
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useEffect, useMemo, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { DeleteApI } from '../../api/Endpoints/DeleteAPI';
import { toast } from 'react-toastify';
import { TriageLeadsAPI } from '../../api/Endpoints/TriageLeadsApi';
import { useNavigate } from 'react-router-dom';
import { WhatsappTemplatesAPI } from '../../api/Endpoints/WhatsappTemplateAPI';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function LeadConvertPopup({ ProjectID, setProjectID, triagID, setTriageID, setShowPopup, func,leadsId, frmDetailsPage,frmWhatsappLeadConvertPage,assigned_to,setValue }) {
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const [formButtonStatus, setFormButtonStatus] = useState({
        label: 'Convert',
        loading: false,
        disabled: false,
    });


    const handleClose = () => {
if(frmWhatsappLeadConvertPage){
setValue("assign_project", null);
setValue("assigned_to", null);
setProjectID(null);
setOpen(false);
func && func()

return
}

        setOpen(false);

        setTimeout(() => {
            setProjectID(0);
            setTriageID(0)
            setShowPopup(false)
        }, 100)

    };

    useEffect(() => {
        if (ProjectID > 0) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [ProjectID]);



    const confirmConvertion = async () => {

        setFormButtonStatus({ ...formButtonStatus, loading: true, disabled: true });
if(frmWhatsappLeadConvertPage){
    const leads = [
        {
          id: leadsId, // Hardcoded or replace with dynamic ID
          project_id:ProjectID,
          assigned_to: assigned_to,
        },
      ];
      const data = { leads };
        const res = await WhatsappTemplatesAPI.WhatsappLeadConverter(data);

        if (res) {
            handleClose()
            toast.success('Successfully Converted', { autoClose: 2000 })
            setFormButtonStatus({ ...formButtonStatus, loading: false, disabled: false });  
            setProjectID([])
            func && func()
        }   
     
          return
      
}
        const res = await TriageLeadsAPI.save({ triage_id: triagID, project_id: ProjectID })
        if (res.data.status == true) {
            handleClose(false)
            toast.success('Successfully Converted', { autoClose: 1000 })
            func && func()
            if (frmDetailsPage) {
                navigate(-1)
            }
            setFormButtonStatus({ ...formButtonStatus, loading: false, disabled: false });
        } else {
            toast.error('Error: Conversion Failed')
            handleClose(false)
            setFormButtonStatus({ ...formButtonStatus, loading: false, disabled: false });
        }
    }


    return (
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    style: {
                        transform: 'translateY(-75%)',
                    },
                }}
            >
                <DialogTitle>Confirm Conversion</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to convert this into Lead?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant='outlined' color='inherit'>Cancel</Button>
                    <LoadingButton onClick={() => confirmConvertion()} loading={formButtonStatus.loading} disabled={formButtonStatus.disabled}
                        variant="outlined" color='primary' type="submit">{formButtonStatus.label}</LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}
